import React from 'react'
import { connect } from 'react-redux'
import { CompanyId, GenerateTeams$Request } from '../../../../services/api.types'
import { generateTeams } from '../../store/TeamManagementActions'
import { getTeamsLoading } from '../../store/TeamManagementSelectors'
import { IGlobalState } from '../../../../Root/store/appReducer'
import GenerateTeams from './GenerateTeams'

interface GenerateTeamsWrapperProps {
  open: boolean
  onClose: () => void
  companyId: CompanyId
  variant?: 'button' | 'iconButton'
  text?: string
}

interface GenerateTeamsDispatchProps {
  generateTeams: (payload: GenerateTeams$Request) => void
}

interface GenerateTeamsStateProps {
  loading: boolean
}

const mapStateToProps = (state: IGlobalState): GenerateTeamsStateProps => ({
  loading: getTeamsLoading(state),
})

const mapDispatchToProps: GenerateTeamsDispatchProps = {
  generateTeams,
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)((props: GenerateTeamsWrapperProps & GenerateTeamsDispatchProps & GenerateTeamsStateProps) => {
  const { generateTeams, loading, ...rest } = props

  const handleSubmit = (payload: GenerateTeams$Request) => {
    generateTeams(payload)
  }

  return <GenerateTeams onSubmit={handleSubmit} loading={loading} {...rest} />
})
